import React, {useContext} from 'react'
import FormTranslationContext from "context/FormTranslationContext";
import getObjectValue from "libs/getObjectValue";
import NoticeTypography from "../../components/inputs/NoticeTypography";
import NoticeYesNoInput from "../../components/inputs/NoticeYesNoInput";
import {Collapse} from "@material-ui/core";
import NoticeTextInput from "../../components/inputs/NoticeTextInput";
import NoticeGlossaryInput from "../../components/inputs/NoticeGlossaryInput";
import {FieldArray} from "formik";
import OrderDetailsLotCriterion from "./OrderDetailsLotCriterion";
import Button from "components/Button";
import GridBlock from "components/GridBlock";
import PlusOneIcon from "@material-ui/icons/PlusOne";
import Tr from "translations/Translations";


export const CRITERION_TYPE = {
    PRICE: {type: "PRICE", criterionName: "Cena", criterionPctgWeight: null, criterionPktWeight: null, criterionOrder: null},
    COST: {type: "COST", criterionName: "Koszt", criterionPctgWeight: null, criterionPktWeight: null, criterionOrder: null},
    QUALITY: {type: "QUALITY", criterionName: "", criterionPctgWeight: null, criterionPktWeight: null, criterionOrder: null}
}

export const getDefaultCriteria = (strategy) => {
    let newCriterions;
    switch (strategy) {
        case "1":
            newCriterions = [CRITERION_TYPE.PRICE]
            break;
        case "2":
            newCriterions = [CRITERION_TYPE.COST]
            break;
        case "3":
            newCriterions = [CRITERION_TYPE.PRICE, CRITERION_TYPE.COST]
            break;
        case "4":
            newCriterions = [CRITERION_TYPE.PRICE, CRITERION_TYPE.QUALITY]
            break;
        case "5":
            newCriterions = [CRITERION_TYPE.COST, CRITERION_TYPE.QUALITY]
            break;
        case "6":
            newCriterions = [CRITERION_TYPE.PRICE, CRITERION_TYPE.COST, CRITERION_TYPE.QUALITY]
            break;
        case "7":
            newCriterions = [CRITERION_TYPE.QUALITY]
            break;
        default:
            newCriterions = [];
    }
    return newCriterions;
}

function OrderDetailsPrimaryLot(
    {
        id,
        formikProps,
        lotNumber,
        realizationTypeX11,
        realizationTypeX12,
        realizationTypeX13
    }) {
    const editable = getObjectValue('_editable', formikProps.values, true);
    const passive = getObjectValue('_passive', formikProps.values, false);
    const onlyNotice = getObjectValue('_onlyNotice', formikProps.values, false);
    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const {getDict} = useContext(FormTranslationContext)

    const changeCriteriaEvaluationStrategy = (strategy) => {
        const newCriterions = getDefaultCriteria(strategy);
        formikProps.setFieldValue(gId("criteria"), newCriterions);
    }

    const removeCriterion = (arrayHelpers, index) => {
        arrayHelpers.remove(index);
    }

    const addCriterion = (arrayHelpers) => {
        arrayHelpers.push(CRITERION_TYPE.QUALITY);
    }
    const addAvailable = (onlyNotice || passive) && ["4", "5", "6", "7"].includes(gVal("criteriaEvaluationStrategy"));
    return (<>
        {!!lotNumber && <NoticeTypography formTrKey={id}>: {lotNumber}</NoticeTypography>}

        <Collapse in={realizationTypeX11 || realizationTypeX12}>
            <NoticeTextInput
                formikProps={formikProps}
                id={gId("evaluationMethodDescription")}
                multiline
            />
        </Collapse>

        <Collapse in={realizationTypeX12}>
            <NoticeYesNoInput
                formikProps={formikProps}
                id={gId("negotiationsPossible")}
                required
            />
        </Collapse>

        <NoticeGlossaryInput
            formikProps={formikProps}
            id={gId("criteriaWeightStrategy")}
            items={getDict("ENUM.015")}
            required
        />

        <NoticeGlossaryInput
            formikProps={formikProps}
            id={gId("criteriaEvaluationStrategy")}
            items={getDict("ENUM.014")}
            onChange={changeCriteriaEvaluationStrategy}
            required
        />

        <Collapse in={realizationTypeX11 || realizationTypeX12}>
            <NoticeYesNoInput
                formikProps={formikProps}
                id={gId("evaluationSocialAspects12")}
                required
            />
            <Collapse in={gVal("evaluationSocialAspects12") === true}>
                <NoticeGlossaryInput
                    formikProps={formikProps}
                    id={gId("evaluationSocialAspects12Info")}
                    items={getDict("SL.MO.030")}
                    multiple
                    required
                />
            </Collapse>
        </Collapse>

        <Collapse in={realizationTypeX13}>
            <NoticeYesNoInput
                formikProps={formikProps}
                id={gId("evaluationSocialAspects3")}
                required
            />
            <Collapse in={gVal("evaluationSocialAspects3") === true}>
                <NoticeGlossaryInput
                    formikProps={formikProps}
                    id={gId("evaluationSocialAspects3Info")}
                    items={getDict("SL.MO.030")}
                    multiple
                    required
                />
            </Collapse>
        </Collapse>

        <FieldArray
            name={gId("criteria")}
            render={(arrayHelpers) => (<>
                {
                    gVal("criteria", true, [])
                        .map((x, i) => (<OrderDetailsLotCriterion
                            key={i}
                            formikProps={formikProps}
                            id={gId("criteria." + i)}
                            index={i}
                            criterion={x}
                            criteriaEvaluationStrategy={gVal("criteriaEvaluationStrategy")}
                            criteriaWeightStrategy={gVal("criteriaWeightStrategy")}
                            removeCriterion={() => removeCriterion(arrayHelpers, i)}
                        />))
                }
                {addAvailable &&
                    <GridBlock justify="center">
                        <Button disabled={!editable} Icon={PlusOneIcon} onClick={() => addCriterion(arrayHelpers)}>{Tr('add_criteria')}</Button>
                    </GridBlock>
                }

            </>)}
        />

    </>)
}

OrderDetailsPrimaryLot.propTypes = {};

export default OrderDetailsPrimaryLot;
